<template>
  <h2>Create new customer</h2>
  <div class="max-w-2xl gap-4 flex flex-col px-4 pb-6 md:px-0 md:pb-0 mt-8">
    <h3>Details</h3>
    <RegistrationDetailsForm v-model="registrationDetails" />
    <h3>Card</h3>
    <CreditCardDetailsForm v-model="creditCardDetails" />
    <div class="self-center md:self-end">
      <AppButton :disabled="!isValid || loading" :is-loading="loading" @click="handleCreateNewCustomer">
        Create Customer
      </AppButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppButton from '@/components/AppButton.vue'
import CreditCardDetailsForm from '@/components/payment/CreditCardDetailsForm.vue'
import type { RegistrationDetails } from '@/components/profile/CustomerDetailsForm.vue'
import RegistrationDetailsForm from '@/components/profile/CustomerDetailsForm.vue'
import { useCreateNewCustomer } from '@/graphql/mutations/createNewCustomer'

import { CreditCardDetails } from '@/graphql/types'
import { RouteName } from '@/routeNames'
import { useResetStore } from '@/services/api'
import { useAuth } from '@/services/auth/provider'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

const registrationDetails = ref<RegistrationDetails | undefined>()
const creditCardDetails = ref<CreditCardDetails | undefined>()

const isValid = computed(() => registrationDetails.value != null && creditCardDetails.value != null)

const { createNewCustomer, loading } = useCreateNewCustomer()
const auth = useAuth()
const { resetStore } = useResetStore()
const router = useRouter()

const handleCreateNewCustomer = async () => {
  if (registrationDetails.value == null || creditCardDetails.value == null) return
  const customer = await createNewCustomer({
    newCustomerDetails: registrationDetails.value,
    creditCardDetails: creditCardDetails.value
  })

  auth.setActiveCustomer(customer.id)
  // reset all cached query results and go to customer details
  resetStore().then(() => {
    router.push({ name: RouteName.MyDetails })
  })
}
</script>
